var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSwapAccount = function SvgSwapAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.85 8.048-3.565-3.824a.687.687 0 0 0-.243-.165A.802.802 0 0 0 13.74 4H12.33c-.145 0-.226.142-.137.239l3.137 3.364H2.174c-.096 0-.174.066-.174.147v1.103c0 .08.078.147.174.147h15.128c.583 0 .907-.566.548-.952ZM2.15 11.952l3.565 3.824c.065.07.148.126.243.165A.8.8 0 0 0 6.26 16H7.67c.145 0 .226-.142.137-.239L4.67 12.397h13.156c.096 0 .174-.066.174-.147v-1.103c0-.08-.078-.147-.174-.147H2.698c-.583 0-.907.566-.548.952Z",
    fill: "#666"
  })));
};
export default SvgSwapAccount;